module.exports = __webpack_public_path__ + "static/lights6-11e32f942d714724ec48ba8a55f58de0.jpg";